import { render, staticRenderFns } from "./Insumos.vue?vue&type=template&id=05f82526&scoped=true"
import script from "./Insumos.vue?vue&type=script&lang=js"
export * from "./Insumos.vue?vue&type=script&lang=js"
import style0 from "./Insumos.vue?vue&type=style&index=0&id=05f82526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f82526",
  null
  
)

export default component.exports